import React from 'react';

import styled from 'styled-components';

export default function Banner() {
  return (
    <StyledBanner>
      <StyledBannerBackground>
        <StyledBannerContentsContainer>
          <StyledTitle>현명한 투자의 시작</StyledTitle>
          <StyledParagraph>
            인텔리퀀트는 당신의 경제적 자유를 돕기 위한 투자 솔루션을 만듭니다.
          </StyledParagraph>
        </StyledBannerContentsContainer>
      </StyledBannerBackground>
    </StyledBanner>
  );
}

const StyledBanner = styled.article`
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.black};
`;

const StyledBannerBackground = styled.div`
  height: 876px;
  ${({ theme }) => theme.flex()};
  background-image: url('images/Home/bannerBackground/3-4-x.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  ${({ theme }) => theme.mobile`
  background-size: cover%;
  height: 100vh;
  `}
`;

const StyledBannerContentsContainer = styled.div`
  margin: 0 20%;
  position: relative;
  bottom: 100px;
  ${({ theme }) => theme.flex('column')};
  text-align: center;

  ${({ theme: { mobile } }) => mobile`
    position: static;
    bottom: 0;
  `}
`;

const StyledTitle = styled.h1`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.pixelToRem(60)};
  font-weight: 700;
  line-height: 1.2;

  ${({ theme }) => theme.mobile`
    font-size: ${theme.pixelToRem(30)};
    text-align: center;
  `}
`;

const StyledParagraph = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.pixelToRem(26)};

  ${({ theme }) => theme.mobile`
    font-size: ${theme.pixelToRem(14)};
    text-align: center;
  `}
`;
